import request from '@/utils/request'

/**
 * SSO Token登录
 * @param {Object} data 登录数据
 * @returns {Promise}
 */
export function ssoTokenLogin(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/login.ssoTokenLogin',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}